/**
 * Company Search — lookup outcome router. A resolved match is auto-selected by
 * the page (it renders the profile directly, sealed state 2), so this component
 * only renders the two remaining honest branches: the ambiguous-match picker
 * (state 4) and the unknown-to-entity-spine scan state (state 3).
 */

import type { LookupView } from "../types";
import { AmbiguousPicker } from "./AmbiguousPicker";
import { UnknownToSpine } from "./UnknownToSpine";

export function LookupResults({
  view,
  query,
  selectedId,
  onSelect,
  onRefine,
}: {
  view: LookupView;
  query: string;
  selectedId: string | null;
  onSelect: (organizationId: string, displayName: string | null) => void;
  onRefine: () => void;
}): JSX.Element | null {
  if (view.kind === "ambiguous") {
    return (
      <AmbiguousPicker
        candidates={view.candidates}
        selectedId={selectedId}
        onSelect={onSelect}
        onRefine={onRefine}
      />
    );
  }
  if (view.kind === "empty") {
    return <UnknownToSpine query={query} />;
  }
  // Resolved — the page auto-selects and renders the profile directly.
  return null;
}
